import axiosConfig from "./axiosConfig";

const deleteDocumentId = async (
  authToken: string,
  type: string,
  number: number
): Promise<void> => {
  await axiosConfig.delete(`/document-ids/${type}/${number}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
};

export default deleteDocumentId;
